import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.m.css";
import Iframe from "react-iframe";

const LoksabhaElectionPoll = ({ partyId }) => {
  return (
    <div className={styles.base}>
      <div className={`${styles["iframe-container"]} container`}>
        <div className={styles["iframe-box"]}>
          <Iframe
            title="vikatan poll"
            frameBorder="0"
            className={styles["iframe-outer"]}
            src={`https://special.vikatan.com/election/2025/mla_performance_poll/index.php?thokkuthi_id=${partyId}`}
          />
        </div>
      </div>
    </div>
  );
};

LoksabhaElectionPoll.propTypes = {
  partyId: PropTypes.string.isRequired
};

export default LoksabhaElectionPoll;
